import NodeWithTranslation from "./NodeWithTranslation";

export default NodeWithTranslation;
